<template>
  <div class="sidebar-container">
    <ul :class="{ top_menu_ul: isTopMenu }">
      <li @click="goTo('Dashboard')" :id="'home-' + activeId + '-' + isMyAccountMenu" :aria-label="$t('nav.home')">
        <img src="../assets/icons/home.png" :class="{ top_menu: isTopMenu }" :alt="$t('nav.home')">
        <span v-if="isTopMenu" class="menu-span">{{ $t('nav.home') }}</span>
      </li>
      <li @click="goTo('LastJourneyView')" :id="'journey-' + activeId + '-' + isMyAccountMenu" :aria-label="$t('nav.journey')" :class="{ 'disabled-button': (isObserverAppRole || lastJourneyID === '' || lastJourneyID === null || lastJourneyID === undefined) }">
        <font-awesome-icon icon="route"
                           class="font-awesome-icon"
                           :class="{ top_menu: isTopMenu }"
        />
        <span v-if="isTopMenu" class="menu-span">{{ $t('nav.journey') }}</span>
      </li>
      <li @click="goTo('TreasureChest')" :id="'treasure-' + activeId + '-' + isMyAccountMenu" :aria-label="$t('nav.treasureChest')" :class="{ 'disabled-button': isObserverAppRole }">
        <img src="../assets/icons/chest.png" :class="{ top_menu: isTopMenu }" :alt="$t('nav.treasureChest')">
        <span v-if="isTopMenu" class="menu-span">{{ $t('nav.treasureChest') }}</span>
      </li>
      <li @click="goTo('Notifications')" :id="'notifications-' + activeId + '-' + isMyAccountMenu" style="position: relative" :aria-label="$t('nav.notifications')">
        <img src="../assets/icons/bell.png" :class="{ top_menu: isTopMenu }" :alt="$t('nav.notifications')">
        <span v-if="isTopMenu" class="menu-span">{{ $t('nav.notifications') }}</span>
        <span v-if="unreadUserNotifications.length > 0 && unreadUserNotifications.length < 99" class="badge-wrapper unread-notifications">{{ unreadUserNotifications.length }}</span>
        <span v-if="unreadUserNotifications.length > 0 && unreadUserNotifications.length >= 99" class="badge-wrapper unread-notifications">99+</span>
      </li>
      <li @click="goTo('Chat')" :id="'chat-' + activeId + '-' + isMyAccountMenu" style="position: relative" :aria-label="$t('nav.chat')" :class="{ 'disabled-button': isObserverAppRole }">
        <v-icon icon="mdi-chat" :size="30" :class="{ top_menu: isTopMenu }"></v-icon>
        <span v-if="isTopMenu" class="menu-span">{{ $t('nav.chat') }}</span>
        <span v-if="!isObserverAppRole && totalUnreadChatMessages > 0 && totalUnreadChatMessages < 99" class="badge-wrapper unread-messages">{{ totalUnreadChatMessages }}</span>
        <span v-if="!isObserverAppRole && totalUnreadChatMessages > 0 && totalUnreadChatMessages >= 99" class="badge-wrapper unread-messages">99+</span>
      </li>
      <li v-if="isTasksPageEnabled" @click="goTo('Tasks')" :id="'tasks-' + activeId + '-' + isMyAccountMenu" :aria-label="$t('nav.pageTitleUpNext')" :class="{ 'disabled-button': isObserverAppRole }">
<!--        <v-icon icon="mdi-clipboard-list-outline" :size="30" :class="{ top_menu: isTopMenu }"></v-icon>-->
        <font-awesome-icon icon="calendar"
                           class="font-awesome-icon"
                           style="height: 26px;"
                           :class="{ top_menu: isTopMenu }"
        />
        <span v-if="isTopMenu" class="menu-span">{{ $t('nav.pageTitleUpNext') }}</span>
      </li>
    </ul>
  </div>
  <ConfirmationModal :isOpened="isUnsavedChangesModalOpened"
                     :title="titleModal"
                     :message="messageModal"
                     @confirm="confirmUnsavedChangesHandler"
                     @cancel="cancelUnsavedChangesHandler"
  />
</template>
<script>
import {computed, onMounted, ref, watch} from "vue";
import router from "@/router";
import ConfirmationModal from "@/components/common/ConfirmationModal";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {useStore} from "vuex";
import {useRoute} from "vue-router";
import { useI18n } from 'vue-i18n';

export default {
  emits: ['sidebarChange', 'routeChange'],
  components: {
    ConfirmationModal,
    FontAwesomeIcon
  },
  props: {
    isTopMenu: {
      type: Boolean,
      default: false
    },
    isMyAccountMenu: {
      type: Boolean
    }
  },
  setup(props, {emit}) {

    const store = useStore();
    const { t } = useI18n();

    const route = useRoute();

    const activeId = ref('');

    const isLogin = ref(false);

    const redirectRedtination = ref('');

    const titleModal = computed(() => t('common.unsavedChangesTitle'));
    const messageModal = computed(() => t('common.unsavedChangesMessage'));

    const isUnsavedChangesModalOpened = ref(false);

    const lastJourneyID = computed(() => store.getters["userPreferences/getLastJourneyID"]);

    const notificationsStatus = ref(false);

    const unreadUserNotifications = computed(() => store.getters["userNotifications/getUnreadUserNotifications"]);

    const totalUnreadChatMessages = computed(() => store.getters['chat/totalUnread']);

    // Observer accounts only follow participants: Journey, Treasure Chest, Chat and Tasks are shown greyed out (router guards block them too)
    const isObserverAppRole = computed(() => store.getters['auth/isCurrentUserObserverAppRole']);

    const isTasksPageEnabled = computed(() => store.getters['tenant/isTasksPageEnabled']);

    // const tenantColor = computed(() => {
    //   return {
    //     '--primary-color': store.state.tenant.tenantinfo.primarycolor
    //   }
    // });

    const cancelUnsavedChangesHandler = () => {
      isUnsavedChangesModalOpened.value = false;
    };

    const confirmUnsavedChangesHandler = () => {
      localStorage.removeItem('journeyCreationModified');
      isUnsavedChangesModalOpened.value = false;
      router.push({name: redirectRedtination.value});
    };

    const goTo = (destination) => {
      emit('routeChange', true);
      activeId.value = '';
      redirectRedtination.value = destination;
      const href = window.location.href;
      if (href.includes('journey-creation')) {
        const result = localStorage.getItem('journeyCreationModified');
        if (result === 'yes') {
          isUnsavedChangesModalOpened.value = true
        } else {
          router.push({name: destination}).then(() => {
            checkActiveRoute(window.location.href);
          });
        }
      }
      else if (destination === 'LastJourneyView' && lastJourneyID.value !== '') {
        router.push('/journey/view/' + lastJourneyID.value).then(() => {
          checkActiveRoute(window.location.href);
        });
      }
      else {
        router.push({name: destination}).then(() => {
          checkActiveRoute(window.location.href);
        });
      }
    };

    const checkActiveRoute = (url) => {
      if(url.includes('dashboard')){
        activeId.value = 'home';
      }
      if(url.includes('treasure-chest')){
        activeId.value = 'treasure';
      }
      if(url.includes('notifications')){
        activeId.value = 'notifications';
      }
      if(url.includes('journey')){
        activeId.value = 'journey';
      }
      if(url.includes('tasks')){
        activeId.value = 'tasks';
      }
    };

    const getActiveNavbarItem = (routePath) => {

      if (routePath === '/dashboard') {
        activeId.value = 'home';
      }
      else if (routePath.startsWith('/journey/map') || routePath.startsWith('/journey-creation') || routePath.startsWith('/journey/view')) {
        activeId.value = 'journey';
      }
      else if (routePath === '/treasure-chest') {
        activeId.value = 'treasure';
      }
      else if (routePath === '/notifications') {
        activeId.value = 'notifications';
      }
      else if (routePath === '/m-tasks') {
        activeId.value = 'tasks';
      }

    };

    const getNotificationsStatus = () => {
      if (unreadUserNotifications.value.length > 0) {
        notificationsStatus.value = true
      } else {
        unreadUserNotifications.value = false
      }
    }

    watch(route, (to) => {
      getActiveNavbarItem(route.path);
    });

    onMounted(async () => {
      await getNotificationsStatus();
      activeId.value = '';
      const url = window.location.href;
      checkActiveRoute(url);
      const location = url.substring(url.lastIndexOf('/') + 1);
      isLogin.value = location === 'logon';
    });

    return {
      // tenantColor,
      activeId,
      isLogin,
      goTo,
      messageModal,
      confirmUnsavedChangesHandler,
      cancelUnsavedChangesHandler,
      titleModal,
      isUnsavedChangesModalOpened,
      lastJourneyID,
      notificationsStatus,
      unreadUserNotifications,
      totalUnreadChatMessages,
      isObserverAppRole,
      isTasksPageEnabled,
    }
  }
}

</script>
<style lang="scss" scoped>
.sidebar-container {
  #home-home-false, #journey-journey-false, #treasure-treasure-false, #notifications-notifications-false, #tasks-tasks-false {
    border-bottom: 2px solid var(--primary-color);
  }
  ul {
    list-style-type: none;
    margin: 0;
    overflow: hidden;
    justify-content: right;
    align-items: center;
    display: flex;
    width: 100%;
    &.top_menu_ul {
      float: right;
      li {
        min-width: 10%;
        display: flex;
        flex-direction: column;
        text-align: center;
        width: fit-content;
        justify-content: center;
        align-items: center;
        padding: 0 3px;

        &.disabled-button {
          cursor: not-allowed;
          pointer-events: none;

          .top_menu {
            color: lightgrey;
            background-color: transparent;
          }

          .menu-span {
            color: lightgrey;
          }

        }
        .badge-wrapper {
          display: flex;
          position: absolute;
          top: 0;
          right: 20px;
          min-width: 15px;
          height: 15px;
          font-size: 12px;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          background: var(--primary-color);
          color: white;
          padding:3px;

          &.unread-notifications {
            right: 18px;
          }

          &.unread-messages {
            right: 12px;
          }

        }

        &:hover {
          cursor: pointer
        }
      }
    }
  }

  li {
    .font-awesome-icon {
      height: 28px;
      padding: 2px;
      color: white;

      &.top_menu {
      color: black;
      }
    }

    img {
      width: auto;
      height: 32px;
      padding: 2px;
      filter: invert(1000);

      &.top_menu:not(.treasure_chest) {
        filter: invert(0);
      }
    }

    .menu-span {
      white-space: nowrap;
    }

    a {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      text-decoration: none;
    }
    span{
      font-size: 12px;
      color: black
    }
  }

}
</style>
